import css from '@styled-system/css';
import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { alignSelf, border, color, compose, layout, shadow, space, typography } from 'styled-system';
import theme from '../theme';
const TextArea = styled.textarea `
  ${css({
    outline: '0',
    borderColor: 'gray.4',
    borderRadius: '1',
    borderStyle: 'solid',
    bg: 'transparent',
    fontFamily: 'body',
    fontSize: '0',
    fontWeight: 'light',
    padding: '2'
})}
  &::placeholder {
    ${css({
    color: 'gray.4',
    opacity: '1' // for mozilla inputs
})}
  }
  &:-webkit-autofill,
  &:-webkit-autofill::first-line,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    ${css({
    fontFamily: 'body',
    fontSize: '0'
})}
  }
  &:disabled {
    ${css({
    bg: 'gray.6',
    cursor: 'not-allowed'
})}
  }
  &:focus {
    ${props => css({
    boxShadow: `0 0 1px 1px ${themeGet('colors.gray.3', 'lightgray')(props)}`,
    borderColor: 'gray.3',
    borderStyle: 'solid',
    borderWidth: '1',
    outline: '0'
})}
  }
  ${props => !props.resize
    ? `
  resize: none;
`
    : null}
  ${compose(alignSelf, color, border, layout, shadow, space, typography)}
`;
TextArea.defaultProps = { theme, resize: true };
export default TextArea;
//# sourceMappingURL=TextArea.js.map